module.exports = __webpack_public_path__ + "img/11.923d611f.png";